import { type FC } from 'react';

interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: string;
  };
}

const EmptyState: FC<EmptyStateProps> = ({ icon, title, description, action }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-16 h-16 rounded-2xl bg-background-100 flex items-center justify-center mb-4">
        <i className={`${icon} text-3xl text-foreground-300`}></i>
      </div>
      <h3 className="text-lg font-semibold text-foreground-700 mb-1">{title}</h3>
      <p className="text-sm text-foreground-500 text-center max-w-sm mb-6">{description}</p>
      {action && (
        <button onClick={action.onClick} className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
          {action.icon && <i className={action.icon}></i>}
          {action.label}
        </button>
      )}
    </div>
  );
};

export default EmptyState;